import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

/**
 * Returns an onKeyDown handler that triggers the given callback on Enter or Space.
 * Use for clickable non-interactive elements (div/span) to satisfy jsx-a11y/click-events-have-key-events.
 * Call e.preventDefault() on Space to avoid page scroll. Pair with tabIndex={0} and role="button" when keeping a div.
 */
export function getClickKeyDownHandler(
  onClick: () => void
): (e: ReactKeyboardEvent<HTMLElement>) => void {
  return (e: ReactKeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };
}

/**
 * Returns an onKeyDown handler for overlay/backdrop that closes on Escape.
 * Use for "click backdrop to close" modals. Pair with tabIndex={0} so backdrop can receive focus.
 */
export function getBackdropKeyDownHandler(
  onClose: () => void
): (e: ReactKeyboardEvent<HTMLElement>) => void {
  return (e: ReactKeyboardEvent<HTMLElement>) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      onClose();
    }
  };
}
